import { render, staticRenderFns } from "./allocationModel.vue?vue&type=template&id=41bf12fa&"
import script from "./allocationModel.vue?vue&type=script&lang=js&"
export * from "./allocationModel.vue?vue&type=script&lang=js&"
import style0 from "./allocationModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports